import Navbar from "@/components/layout/Navbar"
import Footer from "@/components/layout/Footer"

export default function MainLayout({ children }: any) {

  return (

    <>
    
      <Navbar />

      <main className="min-h-screen">
  {children}
</main>

      <Footer />

    </>

  )

}